/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable react/jsx-no-comment-textnodes */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/*eslint-disable-next-line @typescript-eslint/ban-ts-comment*/
import React, { useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import Grid from '@mui/material/Grid';
import { Autocomplete, IconButton, TextField } from '@mui/material';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import type { ApiResponse, RootState, appConfigs } from '../types/types';
import { getAllCampaigns } from 'src/services/campaignService';
import { CAMPAIGN_START_DATE, CAMPAIGN_END_DATE, BRANDNAME, CAMPAIGN_Group, EMAIL_TEMPLATE, TRIGGER_CAMPAIGN_ERROR, TRIGGER_NAME_ERROR, TRIGGER_STARTDATE_ERROR, VALID_TRIGGER_NAME_ERROR, SEND_TEST_EMAIL } from 'src/constants/constant';
import SendTestEmail from '../SendTestEmail/SendTestEmail';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
import TemplatePreview from '../TemplatePreview/TemplatePreview';
//@ts-ignore
import { ViewStrokeRounded, Image03Icon, MailSend02Icon, Calendar03Icon } from '@hugeicons-pro/core-stroke-rounded';
import { NotificationManager } from 'react-notifications';
import { checkEventPermission } from 'src/common/utility/utility';
import CustomTooltip from '../CustomTooltip/CustomTooltip';
//@ts-ignore
import { ArrowDown01Icon } from '@hugeicons-pro/core-stroke-standard';

export interface CampaignDetails {
    endOn: string;
    brandName: string;
    groupName: string;
    templateName: string;
    name?: string;
    campaignId?: string;
    startOn: string;
    templateId?: number;
    templateIdentifier?: string;
    templateVersion?: string;
    templateContent?: string;
}

export interface TriggerFormData {
    triggername: string;
    campaignId: string;
    startOn: string;
    triggerenddate?: string;
    templateId?: number;
    templateIdentifier?: string;
    templateVersion?: string;
    id?: number;
    templateContent?: string;
    isActive?: boolean;
    createdByName?: string;
    createdOn?: string;
    updatedByName?: string;
    updatedOn?: string;
}

interface ScheduleTriggerProps {
    savedTriggerData: TriggerFormData;
    onFormValidation: (isValid: boolean) => void;
    onDataSubmit: (data: TriggerFormData) => void;
    submitAttempted?: boolean; // New prop to handle submission attempt
}

const validationSchema = Yup.object().shape({
    triggername: Yup.string()
        .trim()
        .required(TRIGGER_NAME_ERROR)
        .matches(
            /^(?!\s*$)[a-zA-Z0-9\s.,]+(?:[-'][a-zA-Z0-9\s.,]+)*$/,
            VALID_TRIGGER_NAME_ERROR
        ),
    campaignId: Yup.string().required(TRIGGER_CAMPAIGN_ERROR),
    startOn: Yup.string().required(TRIGGER_STARTDATE_ERROR)
});

const EditScheduleTrigger: React.FC<ScheduleTriggerProps> = ({
    savedTriggerData,
    onFormValidation,
    onDataSubmit,
    submitAttempted = false
}) => {
    const [campaigns, setCampaigns] = useState<CampaignDetails[]>([]);
    const [selectedCampaignDetails, setSelectedCampaignDetails] = useState<CampaignDetails | null>(null);
    const { user } = useSelector((state: RootState) => state.auth);
    const [hasAttemptedSubmit, setHasAttemptedSubmit] = useState(false);
    const [testEmailModalOpen, setTestEmailModalOpen] = useState(false);
    const [templateId, setTemplateId] = useState(0);
    const [triggerId, setTriggerId] = useState(0);
    const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
    const [savedData, setSavedData] = useState<TriggerFormData | null>(null);
    const [imageKey, setImageKey] = useState<number>(Date.now());
    const storedAppConfig = localStorage.getItem("appConfigs");
    const [isManualCampaignChange, setIsManualCampaignChange] = useState(false);

    const parsedAppConfig = storedAppConfig
        ? (JSON.parse(storedAppConfig) as appConfigs[])
        : []; // Default to an empty array if null

    const TemplateImagePublicURL = parsedAppConfig.find(
        (item) => item.configName === "TemplateImagePublicURL"
    )?.configValue;
    const [dailyMaxSendCount, setDailyMaxSendCount] = useState<number>(0);
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    const totalNpiRecords = Number(sessionStorage.getItem("totalNpiRecords")) || 0;

    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        if (storedAppConfig) {
            try {
                const parsedAppConfig = JSON.parse(storedAppConfig) as appConfigs[];

                const dailyLimit = parsedAppConfig.find(item => item.configName === "DailyMaxSendCount")?.configValue;
                console.log(dailyLimit);
                // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                setDailyMaxSendCount(Number(dailyLimit) || 0);
            } catch (error) {
                console.error("Error parsing appConfigs:", error);
            }
        }
    }, []);

    const {
        control,
        formState: { errors, isValid },
        setValue,
        watch,
        trigger: triggerValidation,
        handleSubmit,
        reset
    } = useForm<TriggerFormData>({
        resolver: yupResolver(validationSchema),
        mode: 'onChange',
        defaultValues: {
            triggername: '',
            campaignId: '',
            startOn: '',
            triggerenddate: ''
        }
    });

    // Watch startOn value to update end date
    const startOnValue = watch('startOn');

    const [isStartDateChanged] = useState(false);

    useEffect(() => {
        // Only update end date when start date changes
        if (isStartDateChanged && startOnValue && dailyMaxSendCount > 0 && totalNpiRecords > 0) {
            const daysNeeded = Math.ceil(totalNpiRecords / dailyMaxSendCount);
            const endDate = moment(startOnValue, "MM/DD/YYYY").add(daysNeeded, "days").format("MM/DD/YYYY");

            // Update only when the start date is changed by the user
            setValue("triggerenddate", endDate);
        }
    }, [startOnValue, isStartDateChanged, dailyMaxSendCount, totalNpiRecords, setValue]);

    useEffect(() => {
        const initializeForm = async (): Promise<void> => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            if (savedTriggerData && savedTriggerData[0]) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                const savedData = savedTriggerData[0];
                setTriggerId(savedData.id);
                setTemplateId(savedData.templateId);
                // Format dates consistently
                const startDate = savedData.startDate ? moment(savedData.startDate).format('MM/DD/YYYY') : '';
                const endDate = savedData.endDate ? moment(savedData.endDate).format('MM/DD/YYYY') : '';

                // Reset form with formatted data
                reset({
                    triggername: savedData.listTriggerName || '',
                    campaignId: savedData.campaignId || '',
                    startOn: startDate,
                    triggerenddate: endDate
                });

                setSavedData(savedData);
                console.log(savedData);
                // Fetch campaigns if not already loaded
                if (campaigns.length === 0) {
                    await getCampaignListData();
                }
            }
        };

        void initializeForm();
    }, [savedTriggerData, reset]);

    useEffect(() => {
        void getCampaignListData();
    }, []);

    // Effect to handle form validation status
    useEffect(() => {
        console.log(isValid);
        onFormValidation(isValid);
    }, [isValid, onFormValidation]);

    const getCampaignListData = async (): Promise<void> => {
        try {
            const ClientId = user?.clientId ?? 0;
            const res: ApiResponse = await getAllCampaigns(ClientId);
            if (res.status === 200) {
                const templateArr = res.data.data
                    .filter((template: any) =>
                        template.isActive === true &&
                        template.isDeleted === false &&
                        template.startOn && template.endOn
                    )
                    .map((template: any): any => ({
                        ...template,
                        name: template.name,
                        id: template.campaignId,
                    }));
                setCampaigns(templateArr as CampaignDetails[]);
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                if (savedTriggerData && savedTriggerData[0]?.campaignId) {
                    const selectedCampaign = templateArr.find(
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        //@ts-ignore
                        campaign => campaign.campaignId === savedTriggerData[0].campaignId
                    );
                    if (selectedCampaign) {
                        setSelectedCampaignDetails(selectedCampaign);
                    }
                }
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };
    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        if (campaigns.length > 0 && savedTriggerData && savedTriggerData[0]?.campaignId) {
            const selectedCampaign = campaigns.find(
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                campaign => campaign.campaignId === savedTriggerData[0].campaignId
            );
            if (selectedCampaign) {
                setSelectedCampaignDetails(selectedCampaign);
            }
        }
    }, [campaigns, savedTriggerData]);
    useEffect(() => {
        // 🟢 Run only once when savedData & campaign are ready
        if (selectedCampaignDetails && savedData && savedData.templateIdentifier) {
            setImageKey(Date.now());
        }
    }, [selectedCampaignDetails?.campaignId]);

    // Update savedData when selectedCampaignDetails changes
    useEffect(() => {
        if (selectedCampaignDetails) {
            setSavedData(prev => prev ? ({
                ...prev,
                templateId: selectedCampaignDetails.templateId,
                templateIdentifier: selectedCampaignDetails.templateIdentifier,
                templateVersion: selectedCampaignDetails.templateVersion,
                templateContent: selectedCampaignDetails.templateContent
            }) : prev);

            // Update templateId state for SendTestEmail
            if (selectedCampaignDetails.templateId) {
                setTemplateId(selectedCampaignDetails.templateId);
            }
            if (isManualCampaignChange) {
                setImageKey(Date.now());
                setIsManualCampaignChange(false);
            }
        }
    }, [selectedCampaignDetails, isManualCampaignChange]);

    // Handle form submission
    const onSubmit = async (data: TriggerFormData): Promise<void> => {

        // Validate campaign expiration
        if (selectedCampaignDetails && moment(selectedCampaignDetails.endOn).isBefore(moment(), "day")) {
            NotificationManager.error("Cannot create a trigger for an expired campaign");
            return;
        }

        // Ensure start and end dates fall within campaign range
        if (
            moment(data.startOn).isBefore(moment(selectedCampaignDetails?.startOn), "day") ||
            moment(data.triggerenddate).isAfter(moment(selectedCampaignDetails?.endOn), "day")
        ) {
            NotificationManager.error("Trigger dates must be within the selected campaign dates");
            return;
        }

        setHasAttemptedSubmit(true);
        const isValidForm = await triggerValidation();

        if (isValidForm) {
            onDataSubmit(data);
            // Reset the attempt flags after successful submission
            setHasAttemptedSubmit(false);
        }

    };
    console.log(submitAttempted);
    // Trigger validation manually when submitAttempted changes
    useEffect(() => {
        if (submitAttempted) {
            void handleSubmit(onSubmit)();
        }
    }, [submitAttempted]);
    useEffect(() => {
        if (isValid && hasAttemptedSubmit) {
            setHasAttemptedSubmit(false);
        }
    }, [isValid]);
    console.log(savedTriggerData);
    const handleCampaignChange = (selectedOption: CampaignDetails | null) => {
        setValue('campaignId', selectedOption?.campaignId ?? '');
        setSelectedCampaignDetails(selectedOption);
        if (selectedOption) {
            setIsManualCampaignChange(true); // Mark manual change
        }
    };


    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={2}>
                <Grid item xs={8} sx={{ paddingRight: '20px' }}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%'
                    }}>
                        {/* Main content container */}
                        <div style={{ flex: 1, overflowY: 'auto' }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <div className="mb-[30px] mt-4">
                                        <Controller
                                            name="triggername"
                                            control={control}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    fullWidth
                                                    autoComplete="off"
                                                    label="List Trigger Name *"
                                                    error={Boolean(errors.triggername)}
                                                    helperText={errors.triggername?.message}
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            '& fieldset': {
                                                                borderColor: errors.triggername && 'red',
                                                            },
                                                        },
                                                    }}
                                                />
                                            )}
                                        />
                                    </div>
                                </Grid>
                            </Grid>

                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <div className="mb-[30px]">
                                        <Controller
                                            name="campaignId"
                                            control={control}
                                            render={({ field: { onChange, value } }) => (
                                                <Autocomplete
                                                    options={campaigns}
                                                    getOptionLabel={(option: CampaignDetails) => {
                                                        // Handle both object and string values
                                                        if (typeof option === 'string') return '';
                                                        return option.name ?? '';
                                                    }}
                                                    popupIcon={
                                                        <HugeiconsIcon
                                                            icon={ArrowDown01Icon}
                                                            size={18}
                                                            color="#3A3A3A"
                                                            strokeWidth={0.2}

                                                        />
                                                    }
                                                    value={campaigns.find(campaign => campaign.campaignId === value) ?? null}
                                                    onChange={(_, newValue) => {
                                                        onChange(newValue?.campaignId ?? '');
                                                        handleCampaignChange(newValue);
                                                    }}
                                                    isOptionEqualToValue={(option, value) =>
                                                        option.campaignId === (value?.campaignId ?? value)
                                                    }
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Campaign *"
                                                            error={Boolean(errors.campaignId)}
                                                            helperText={errors.campaignId?.message}
                                                        />
                                                    )}
                                                />
                                            )}
                                        />
                                    </div>
                                </Grid>
                            </Grid>

                            {selectedCampaignDetails && (
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sx={{ paddingTop: '0px', marginLeft: '16px', marginBottom: '20px' }}>
                                        <div className="campaign-details" >
                                            <p className='text-muted' style={{
                                                marginBottom: '12px',
                                            }}><strong>{CAMPAIGN_START_DATE} : </strong> {moment(selectedCampaignDetails.startOn).format('MM/DD/YYYY')}</p>
                                            <p className='text-muted' style={{
                                                marginBottom: '12px',
                                            }}><strong>{CAMPAIGN_END_DATE} : </strong> {moment(selectedCampaignDetails.endOn).format('MM/DD/YYYY')}</p>
                                            <p className='text-muted' style={{
                                                marginBottom: '12px',
                                            }}><strong>{BRANDNAME} : </strong> {selectedCampaignDetails.brandName}</p>
                                            <p className='text-muted' style={{
                                                marginBottom: '12px',
                                            }}><strong>{CAMPAIGN_Group} : </strong> {selectedCampaignDetails.groupName}</p>
                                            <p className='text-muted' style={{
                                                marginBottom: '12px',
                                            }}><strong>{EMAIL_TEMPLATE} : </strong> {selectedCampaignDetails.templateName}</p>
                                        </div>
                                    </Grid>
                                </Grid>
                            )}
                        </div>

                        {/* Fixed date fields at bottom */}
                        <div style={{
                            marginTop: 'auto',
                            borderTop: '1px solid #D3D3D3',
                            paddingTop: '20px'
                        }}>
                            <Grid container spacing={2} sx={{ marginTop: '5px' }}>
                                <Grid item xs={6}>
                                    <div className="mb-[30px]">
                                        <Controller
                                            name="startOn"
                                            control={control}
                                            render={({ field }) => (
                                                <div className='datepicker-container'>
                                                    <LocalizationProvider dateAdapter={AdapterMoment}>
                                                        <DatePicker
                                                            label="Trigger Start Date *"
                                                            value={field.value ? moment(field.value, 'MM/DD/YYYY') : null}
                                                            onChange={(newValue) => {
                                                                const formattedDate = moment(newValue).format("MM/DD/YYYY");
                                                                field.onChange(formattedDate);
                                                                if (dailyMaxSendCount > 0 && totalNpiRecords > 0) {
                                                                    const daysNeeded = Math.ceil(totalNpiRecords / dailyMaxSendCount);
                                                                    const endDate = moment(formattedDate, "MM/DD/YYYY").add(daysNeeded, "days").format("MM/DD/YYYY");
                                                                    setValue("triggerenddate", endDate);
                                                                }
                                                            }}
                                                            minDate={moment()}
                                                            slotProps={{
                                                                textField: {
                                                                    error: Boolean(errors.startOn),
                                                                    helperText: errors.startOn?.message
                                                                }
                                                            }}
                                                            slots={{
                                                                openPickerIcon: () => (
                                                                    <HugeiconsIcon
                                                                        icon={Calendar03Icon}
                                                                        size={18}
                                                                        color="#3A3A3A"
                                                                        strokeWidth={0.2}
                                                                    />
                                                                )
                                                            }}
                                                        />
                                                    </LocalizationProvider>
                                                </div>
                                            )}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={6}>
                                    <div>
                                        <Controller
                                            name="triggerenddate"
                                            control={control}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    fullWidth
                                                    autoComplete="off"
                                                    label="Trigger End Date"
                                                    disabled
                                                    value={field.value ? moment(field.value).format('MM/DD/YYYY') : 'MM/DD/YYYY'}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    placeholder="Trigger End Date"
                                                />
                                            )}
                                        />
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                </Grid>

                <Grid item xs={4} sx={{ paddingRight: '20px' }}>
                    <div className="flex justify-start items-center gap-2 mb-[10px]">
                        <div className="text-16 font-semibold text-muted">Template Preview</div>
                        {(checkEventPermission('LISTTRIGGER_SEND_TEST_EMAIL') && savedData?.isActive === true) &&
                            // <div className="text-14 font-[600] text-red cursor-pointer" onClick={() => setTestEmailModalOpen(true)}>
                            //     Send Test Email
                            // </div>
                            <div className="icon-hover-container">
                                <CustomTooltip title={SEND_TEST_EMAIL} placement='bottom' arrow={false}>
                                    <IconButton onClick={() => setTestEmailModalOpen(true)}>
                                        <HugeiconsIcon
                                            icon={MailSend02Icon}
                                            size={24}
                                            strokeWidth={0.2}
                                            color="#3a3a3a"
                                        />
                                    </IconButton>
                                </CustomTooltip>
                            </div>
                        }
                    </div>
                    <div
                        className="relative cursor-pointer flex justify-center items-center h-[300px] border border-[#e6ecf2] rounded-lg"
                        onClick={() => setIsPreviewModalOpen(true)}
                    >
                        {savedData?.templateIdentifier ? (
                            <img
                                key={imageKey}
                                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                                src={`${TemplateImagePublicURL}Template/${savedData.templateIdentifier}/${savedData.templateVersion}/Template_Large.png?t=${imageKey}`}
                                alt="Template Preview"
                                className="icon-hover"
                                onError={(e) => {
                                    (e.target as HTMLImageElement).style.display = 'none';
                                    console.error('Failed to load image:', (e.target as HTMLImageElement).src);
                                }}
                                style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }}
                            />
                        ) : (
                            <HugeiconsIcon
                                icon={Image03Icon}
                                size={50}
                                color="#6B7280"
                                className="block" // Show icon when image is not available
                            />
                        )}

                        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 hover:opacity-100 transition-opacity cursor-pointer rounded-lg">
                            <HugeiconsIcon
                                icon={ViewStrokeRounded}
                                size={24}
                                color="currentcolor"
                                strokeWidth={0.5}
                                className="cursor-pointer text-white"
                            />
                        </div>
                    </div>
                    {(savedData?.createdOn || savedData?.createdByName || savedData?.updatedOn || savedData?.updatedByName) && (
                        <div className="mt-3 text-[14px] text-gray-700 space-y-1">
                            {(savedData?.createdOn || savedData?.createdByName) && (
                                <div className='text-14 text-muted'>
                                    <span className="font-semibold text-muted">Created:</span>{" "}
                                    {savedData?.createdOn && moment(savedData.createdOn).format("MM/DD/YYYY h:mmA")}
                                    {savedData?.createdByName && (
                                        <span className="italic text-muted"> ({savedData.createdByName})</span>
                                    )}
                                </div>
                            )}
                            {(savedData?.updatedOn || savedData?.updatedByName) && (
                                <div className='text-14 text-muted'>
                                    <span className="font-semibold">Last Updated:</span>{" "}
                                    {savedData?.updatedOn && moment(savedData.updatedOn).format("MM/DD/YYYY h:mmA")}
                                    {savedData?.updatedByName && (
                                        <span className="italic text-muted"> ({savedData.updatedByName})</span>
                                    )}
                                </div>
                            )}
                        </div>
                    )}

                </Grid>
            </Grid>
            <SendTestEmail open={testEmailModalOpen} onClose={() => setTestEmailModalOpen(false)} Type={"ListTrigger"} TypeId={triggerId} TemplateId={templateId} />
            <TemplatePreview
                isOpen={isPreviewModalOpen}
                onClose={() => setIsPreviewModalOpen(false)}
                content={savedData?.templateContent ?? ''}
                campaignType="TriggerCampaign"
                campaignId={selectedCampaignDetails?.campaignId}
            />
        </form>
    );
};

export default EditScheduleTrigger;